<template>
  <div class="commonProductItem" :class="customClass" @click="handleJump()">
    <img class="left" :src="item.cover" alt="">
    <!-- <image class="br-12 mr-20 bg-F5F5F5 common-border border-box f-shrink" :src="item.cover" style="width:230rpx;height: 184rpx;">
		</image> -->
    <div class="right">
      <div class="title  text-ellipsis-1">{{ item.productName}}</div>
      <div class="remark">{{item.types ?  $t('lang.t286') + ':' : ''}}{{ item.types }}</div>
      <div class="detail">
        <div class="list text-ellipsis-overflow-1" v-for="(v,i) in item.productAttributes">{{v}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'commonProductItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    customClass: {
      type: String,
      default: 'mt-20',
    },
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val)
        val.types = val.productTypes.join('')
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    // 跳转产品详情页面
    handleJump() {
      // console.log(this.item)
      this.$emit('goDetail', this.item)
      // this.$nav.push('/subPackage/enterprise/pages/product-detail/index',{productCode: this.item.productCode });
    },
  },
}
</script>
<style scoped>
.text-ellipsis-1 {
  /* overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  overflow: hidden;
}
.commonProductItem {
  display: flex;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 10px;
}
.commonProductItem .left {
  display: block;
  width: 115px;
  height: 92px;
  margin-right: 10px;
  border-radius: 6px;
  flex-shrink: 0;
  background-color: #f5f5f5;
}
.right {
  flex: 1;
  display: flex;
  flex-flow: column wrap;
  margin-left: auto;
}
.right .title {
  font-size: 14px;
  color: #262626;
}
.right .remark {
  margin-top: 5px;
  font-size: 12px;
  color: #8c8c8c;
}
.right .detail {
  height: 62px;
  overflow: hidden;
}
.right .detail .list {
  max-width: 212px;
  font-size: 12px;
  margin-top: 6px;
  border-radius: 4px;
  display: inline-block;
  color: #9e9e9e;
  margin-right: 5px;
  padding: 2px 4px;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
}
</style>